import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';

@Component({
  selector: 'app-stafflist-admin',
  standalone: true,
  imports: [NgFor, NgIf, RouterModule],
  templateUrl: './stafflist-admin.component.html',
  styleUrl: './stafflist-admin.component.css'
})
export class StafflistAdminComponent implements OnInit {

  staffList: any[] = [];

  constructor(
    private userStaffService: UserStaffService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadStaffList();
  }

  private loadStaffList(): void {
    this.userStaffService.getUserStaff().subscribe({
      next: (res: any) => {
        this.staffList = res?.data || [];
      },
      error: err => {
        console.error('Failed to load staff list', err);
      }
    });
  }

  // 👉 Navigate under selected staff
  onRowClick(staff: any): void {
  const id = staff?.id;

  if (!id) {
    console.error('staff.id missing', staff);
    return;
  }

  // 👉 Always land on first tab
  this.router.navigate(['/admin-panel/staff', id, 'issue-stock']);
}
}
